import { Box, Paper, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { InternalLinkButton } from '@omnea-app/fe-routing/InternalLinkButton'
import { customDashboardAnalytics } from '../../customDashboardAnalytics'
import { customDashboardsHref } from '../../routing/routes'

// We use container queries here because we're in a variable width section on the dashboard (sidebar can be collapsed)
const VERTICAL_LAYOUT_BREAKPOINT = 600
const NARROW_IMAGE_BREAKPOINT = 400
const ARTWORK_WIDTH = 260

export const CustomDashboardsBanner = () => {
  const { t } = useTranslation('reporting', { keyPrefix: 'custom-dashboards.home-banner' })
  const { user } = useAuthenticatedUser()

  if (!user.isAdmin) {
    return null
  }

  return (
    <Paper sx={{ maxWidth: '100%', mb: 3, containerType: 'inline-size', overflow: 'hidden' }}>
      <Stack
        direction="row"
        sx={(theme) => ({
          [theme.containerQueries.down(VERTICAL_LAYOUT_BREAKPOINT)]: {
            flexDirection: 'column-reverse',
          },
        })}
      >
        <Stack sx={{ flexGrow: 1, p: 5 }}>
          <Typography variant="upsized-semiBold">{t('title')}</Typography>
          <Typography variant="body-regular" sx={{ color: 'text.muted' }}>
            {t('body')}
          </Typography>

          <Stack direction="row" gap={3} sx={{ pt: 6 }}>
            <InternalLinkButton
              variant="contained"
              color="primary"
              href={customDashboardsHref}
              onClick={() => customDashboardAnalytics.homeBannerClicked()}
            >
              {t('cta')}
            </InternalLinkButton>
          </Stack>
        </Stack>

        <Box
          component="img"
          src="/app/assets/custom-dashboards-banner.png"
          alt=""
          sx={(theme) => ({
            width: ARTWORK_WIDTH,
            [theme.containerQueries.down(VERTICAL_LAYOUT_BREAKPOINT)]: {
              width: '100%',
              height: 100,
            },
            // When we get really small, the image at 100px high looks a bit overly zoomed, so go even smaller
            [theme.containerQueries.down(NARROW_IMAGE_BREAKPOINT)]: {
              height: 80,
            },
            flexShrink: 0,
            objectFit: 'cover',
          })}
        />
      </Stack>
    </Paper>
  )
}
